
import SettingsProfile from './Profile/Profile';
import './Settings.css'

function Settings({ currentUser, userConfig, page }) {

    return (
        <div>
            {page == 'profile' ? <SettingsProfile /> : null}
        </div>
    );
}


export default Settings;